import gql from "graphql-tag";

export const LIST_CLIENT_DISPATCHES = gql`
  query clientDispatches($filter: ClientDispatchesFilter, $pagination: PaginationInput) {
    clientDispatches(filter: $filter, pagination: $pagination) {
      entries {
        id
        status
        originWarehouseId
        partnerId
        partnerName
        dispatchDate
        reference
        stordOrderNumber
        totalQuantity
        serialsPending
        shippedAt
        createdAt
      }
      metadata {
        before
        after
        limit
      }
    }
  }
`;

export const GET_CLIENT_DISPATCH = gql`
  query clientDispatch($id: ID!) {
    clientDispatch(id: $id) {
      id
      status
      originWarehouseId
      partnerId
      partnerName
      deliveryAddress {
        addressId
        label
        name
        attName
        phoneNr
        addressLine1
        addressLine2
        postcode
        city
        stateProvince
        countryCode
      }
      dispatchDate
      reference
      carrierReference
      stordOrderNumber
      notes
      totalQuantity
      serialsPending
      unacceptedSerials {
        key
        code
        message
      }
      cancelReason
      shippedAt
      cancelledAt
      lines {
        id
        palletId
        kind
        sku
        quantity
        serialNrs
      }
    }
  }
`;

export const ON_CLIENT_DISPATCH_UPDATED = gql`
  subscription onClientDispatchUpdated {
    clientDispatchUpdated {
      id
    }
  }
`;

export const CLIENT_DISPATCHES_MISSING_SERIALS = gql`
  query clientDispatchesMissingSerials($partnerId: ID, $from: Date, $to: Date) {
    clientDispatchesMissingSerials(partnerId: $partnerId, from: $from, to: $to) {
      id
      partnerName
      reference
      stordOrderNumber
      serialsPending
      shippedAt
    }
  }
`;

export const CLIENT_SHIPPED_SERIALS = gql`
  query clientShippedSerials($partnerId: ID, $from: Date, $to: Date) {
    clientShippedSerials(partnerId: $partnerId, from: $from, to: $to) {
      serial
      sku
      clientDispatchId
      reference
      partnerId
      partnerName
      originWarehouseId
      shippedAt
    }
  }
`;
